import * as api from './api'
import { AppDispatch } from 'src/app/store'
import * as reducers from './slice.reducers'
import { updateCTCookie } from 'src/core/helpers'
import { ConsentPayload, User } from 'src/core/models'
import { transformUserRegisterForm } from './transformers/user-register.transformer'

export const getWidgetUsers = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setLoading(true))
    const { data } = await api.fetchWidgetUsers()
    dispatch(reducers.setLoading(false))
    dispatch(reducers.setWidgetUsers(data))
  } catch (error) {
    dispatch(reducers.setErrorMessage(error))
  }
}

export const changeUserLanguage = (payload) => async (dispatch: AppDispatch) => {
  const user = await api.changeUserLanguageRequest(payload)
  setTimeout(() => {
    dispatch(reducers.setUser(user))
  }, 300)
}

export const changeUserCurrency = (payload) => async (dispatch: AppDispatch) => {
  const user = await api.changeUserCurrencyAPI(payload)
  dispatch(reducers.setUser(user))
}

export const changeUserConsent = (payload: ConsentPayload) => async (dispatch: AppDispatch) => {
  const user = await api.changeUserConsentAPI(payload)
  dispatch(reducers.setUser(user))
}

export const createUser = (payload: any, isOnlyOffsetter = false) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setUserRegisterLoading(true))
    const body = transformUserRegisterForm(payload, isOnlyOffsetter)
    const filterResp = await api.existUserAPI(body.email)
    if (filterResp !== 'SUCCESS') {
      throw filterResp
    }
    await api.registerUserAPI(body)
    dispatch(reducers.setUserRegisterLoading(false))
    dispatch(reducers.setUserRegisterSuccess(true))
    dispatch(reducers.setUserRegisterEmail(body.email))
  } catch (error) {
    dispatch(reducers.setUserRegisterError(error))
    dispatch(reducers.setUserRegisterLoading(false))
    dispatch(reducers.setUserRegisterSuccess(false))
  }
}

export const validateUserEmail = (value: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setValidateEmailLoading(true))
    const filterResp = await api.validateEmailAPI(value)
    if (filterResp !== 'SUCCESS') {
      dispatch(reducers.setValidateEmailLoading(false))
      dispatch(reducers.setValidateEmailSuccess(false))
    } else {
      dispatch(reducers.setValidateEmailLoading(false))
      dispatch(reducers.setValidateEmailSuccess(true))
    }
    dispatch(reducers.setValidateEmailError(filterResp))
  } catch (error) {
    dispatch(reducers.setValidateEmailLoading(false))
    dispatch(reducers.setValidateEmailSuccess(false))
  }
}

export const validateUserEmailForStockSale = (value: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setValidateEmailForStockSaleLoading(true))
    const filterResp = await api.validateEmailAPI(value, true)
    if (filterResp !== 'SUCCESS') {
      dispatch(reducers.setValidateEmailForStockSaleLoading(false))
      dispatch(reducers.setValidateEmailForStockSaleSuccess(false))
    } else {
      dispatch(reducers.setValidateEmailForStockSaleLoading(false))
      dispatch(reducers.setValidateEmailForStockSaleSuccess(true))
    }
    dispatch(reducers.setValidateEmailForStockSaleError(filterResp))
  } catch (error) {
    dispatch(reducers.setValidateEmailForStockSaleLoading(false))
    dispatch(reducers.setValidateEmailForStockSaleSuccess(false))
  }
}

export const changePassword = (payload: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setChangePasswordLoading(true))
    await api.changePasswordAPI(payload)
    dispatch(reducers.setChangePasswordLoading(false))
    dispatch(reducers.setChangePasswordSuccess(true))
  } catch (error) {
    dispatch(reducers.setChangePasswordError(error?.response?.data?.message))
    dispatch(reducers.setChangePasswordLoading(false))
    dispatch(reducers.setChangePasswordSuccess(false))
  }
}

export const updateUserAuthDetails = (payload: any) => async (dispatch: AppDispatch) => {
  const user: User = await api.updateUserLoginPersonalDataAPI(payload)
  dispatch(reducers.setUser(user))
}

export const updateUserLoginPersonalData = (payload: any, oldEmail: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setUpdateUserLoginPersonalDataLoading(true))
    // Validate Email
    if (payload?.email !== oldEmail) {
      const emailRes = await api.existUserAPI(payload?.email)
      if (emailRes !== 'SUCCESS') {
        throw emailRes
      }
    }
    const user: User = await api.updateUserLoginPersonalDataAPI(payload)
    dispatch(reducers.setUpdateUserLoginPersonalDataLoading(false))
    dispatch(reducers.setUpdateUserLoginPersonalDataSuccess(true))
    dispatch(reducers.setUpdateUserLoginPersonalDataNewEmail(user?.email !== oldEmail))
    dispatch(reducers.setUser(user))
    updateCTCookie('ct-country', user.country_code)
  } catch (error) {
    if (error === 'ALREADY_EXIST') {
      dispatch(reducers.setUpdateUserLoginPersonalDataError('ALREADY_EXIST'))
    } else {
      dispatch(reducers.setUpdateUserLoginPersonalDataError(error?.response?.data?.message))
    }
    dispatch(reducers.setUpdateUserLoginPersonalDataLoading(false))
    dispatch(reducers.setUpdateUserLoginPersonalDataSuccess(false))
    dispatch(reducers.setUpdateUserLoginPersonalDataNewEmail(null))
  }
}

export const deleteAuthUser = (payload: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setDeleteAuthUserLoading(true))
    await api.deleteAuthUserAPI(payload)
    dispatch(reducers.setDeleteAuthUserLoading(false))
    dispatch(reducers.setDeleteAuthUserSuccess(true))
  } catch (error) {
    dispatch(reducers.setDeleteAuthUserErrorMessage(error?.response?.data?.detail))
    dispatch(reducers.setDeleteAuthUserLoading(false))
    dispatch(reducers.setDeleteAuthUserSuccess(false))
  }
}

export const getUserSubscriptions = () => async (dispatch: AppDispatch) => {
  const subscriptions = await api.getUsersubscriptionsAPI()
  dispatch(reducers.setUserSubscriptions(subscriptions))
}
